module.exports = __webpack_public_path__ + "media/images/city/019-memorial-hall-4cac9bacb9524bd9ae76085cf09e4059.svg";